import createInstanceAddReduxUtil from '../../../redux/actions/create/create-instance'
import createInstancesAddReduxUtil from '../../../redux/actions/create/create-instances'
import updateStateReduxAction from '../update-state'

export default function createReduxAction (action) {
  return (dispatch, getState) => {
    const stateWrapper = {
      state: { ...getState() },
      dispatch
    }
    let data
    if (Array.isArray(action.payload.data)) {
      // Add the instances to the state
      data = createInstancesAddReduxUtil(stateWrapper, action.payload)
    } else {
      // Add the instance to the state
      data = createInstanceAddReduxUtil(stateWrapper, action.payload)
    }
    // Set the new state
    dispatch(updateStateReduxAction({
      actionType: action.type,
      state: stateWrapper.state
    }))
    return data
  }
}
